import { render, staticRenderFns } from "./MixedNumeration.vue?vue&type=template&id=6bc1cc6a&"
import script from "./MixedNumeration.vue?vue&type=script&lang=js&"
export * from "./MixedNumeration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports